import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import { APIContext } from "../Contexts/APIContext";
import { TelemetryContext } from "../Contexts/TelemetryContext";
import {
    TERMS_AND_CONDITIONS_FILE_NAME,
    TERMS_AND_CONDITIONS_SETTING_NAME,
    TERMS_AND_CONDITIONS_UPDATE_MESSAGE,
    TERMS_AND_CONDITIONS_VERSION,
    openTermsAndConditions
} from "./TermsAndConditions";

export default function TermsAndConditionsDialog() {
    const { authenticated } = useContext(AuthContext);
    const { getUserSetting, setUserSetting, showMessage } = useContext(APIContext);
    const { logFileAccess } = useContext(TelemetryContext);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!authenticated) {
            setOpen(false);
            return;
        }

        getUserSetting(TERMS_AND_CONDITIONS_SETTING_NAME, (value) => {
            setOpen(value !== TERMS_AND_CONDITIONS_VERSION);
        });
    }, [authenticated]);

    const handleAccept = () => {
        setUserSetting(TERMS_AND_CONDITIONS_SETTING_NAME, TERMS_AND_CONDITIONS_VERSION, (success) => {
            if (!success) {
                return;
            }

            setOpen(false);
            window.dispatchEvent(new Event("terms-accepted"));
            showMessage("success", "Your acceptance has been saved.");
        });
    };

    const handleOpenTermsAndConditions = () => {
        logFileAccess(TERMS_AND_CONDITIONS_FILE_NAME, "TermsAndConditionsDialog");
        openTermsAndConditions();
    };

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            disableEscapeKeyDown
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>TRICS Licence Terms & Conditions Updated</DialogTitle>
            <DialogContent>
                <Typography paragraph>
                    {TERMS_AND_CONDITIONS_UPDATE_MESSAGE}
                </Typography>
                <Link
                    component="button"
                    type="button"
                    underline="always"
                    onClick={handleOpenTermsAndConditions}
                >
                    View {TERMS_AND_CONDITIONS_FILE_NAME}
                </Link>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAccept} variant="contained">
                    Accept
                </Button>
            </DialogActions>
        </Dialog>
    );
}
